export const api = {
  products: '/products-list',
  productSearch: '/products-search',
  productSave: '/product-details',
  productById: '/product-details',
  productImagesById: '/product-images',
  kitting: '/kitting-list',
  productRemoveImageById: '/product-image-delete',
  productLessById: '/product-details',
  productKittingById: '/kitting-details',
  productKittingSave: '/kitting',
  productGroupingList: '/dummy-list',
  createProductGrouping: '/dummy',
  getProductGroupingDetail: '/dummy-details',
  productCategories: '/product-categories-list',
  pwpFoc: '/promotion-free-item-list',
  PwpFocSave: '/promotion-free-item',
  kittingSearch: '/kitting-list',
  pwpFocById: '/promotion-free-item-details',
  kittingStatsById: '/kitting-in-sale',
}
